import {
  FETCH_EVENT_LIST,
  FETCH_EVENT_LIST_DONE,
  FETCH_EVENT_LIST_ERROR,
  EVENT_SELECTED,
  CLEAR_EVENT_DETAILS,
  FETCH_EVENT_DETAILS,
  FETCH_EVENT_DETAILS_DONE,
  FETCH_EVENT_DETAILS_ERROR,
  FETCH_EVENT_TYPES,
  FETCH_EVENT_TYPES_DONE,
  FETCH_EVENT_PRODUCTS,
  FETCH_EVENT_PRODUCTS_DONE,
  FETCH_EVENT_PRODUCTS_ERROR,
  STORE_SELECTED_PRODUCT,
  FETCH_EVENT_STATUS_DONE,
  CLEAR_EVENT_STATUS,
  RECORD_STREAM_ACTIVITY,
  RECORD_STREAM_ACTIVITY_DONE,
  RECORD_STREAM_ACTIVITY_ERROR
} from "./constants";

export const fetchList = (filters) => {
  if (filters.status.length === 0) {
    delete filters.status;
  }
  return {
    type: FETCH_EVENT_LIST,
    filters
  };
};

export const fetchListDone = (events, tabName) => ({
  type: FETCH_EVENT_LIST_DONE,
  events,
  tabName
});

export const fetchListError = (errors) => ({
  type: FETCH_EVENT_LIST_ERROR,
  errors
});

export const eventSelected = (event) => ({
  type: EVENT_SELECTED,
  event
});

export const fetchEventDetails = (event) => ({
  type: FETCH_EVENT_DETAILS,
  event
});

export const clearEventDetails = () => ({
  type: CLEAR_EVENT_DETAILS
});

export const fetchEventDetailsDone = (event) => ({
  type: FETCH_EVENT_DETAILS_DONE,
  event
});

export const fetchEventDetailsError = (errors) => ({
  type: FETCH_EVENT_DETAILS_ERROR,
  errors
});

export const fetchEventTypes = () => ({
  type: FETCH_EVENT_TYPES
});

export const fetchEventTypesDone = (types) => ({
  type: FETCH_EVENT_TYPES_DONE,
  types
});

export const fetchEventTypesError = (error) => ({
  type: FETCH_EVENT_DETAILS_ERROR,
  error
});

export const fetchEventProducts = (eventId) => ({
  type: FETCH_EVENT_PRODUCTS,
  eventId
});

export const fetchEventProductsDone = (products) => ({
  type: FETCH_EVENT_PRODUCTS_DONE,
  products
});

export const fetchEventProductsError = (error) => ({
  type: FETCH_EVENT_PRODUCTS_ERROR,
  error
});

export const storeSelectedProduct = (selectedProduct) => ({
  type: STORE_SELECTED_PRODUCT,
  selectedProduct
});

export const fetchEventStatusDone = (payload) => ({
  type: FETCH_EVENT_STATUS_DONE,
  payload
});

export const clearEventStatus = () => ({
  type: CLEAR_EVENT_STATUS
});

export const recordStreamActivity = (activity) => ({
  type: RECORD_STREAM_ACTIVITY,
  activity
});

export const recordStreamActivityDone = () => ({
  type: RECORD_STREAM_ACTIVITY_DONE
});

export const recordStreamActivityError = (error) => ({
  type: RECORD_STREAM_ACTIVITY_ERROR,
  error
});
